var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',_vm._b({attrs:{"icon":_vm.resolvedIcon,"width":_vm.width,"height":_vm.height,"color":_vm.color,"rotate":_vm.rotate,"flip":_vm.flip,"inline":_vm.inline,"h-flip":_vm.hFlip,"v-flip":_vm.vFlip,"align":_vm.align},on:{"click":function($event){return _vm.$emit('click', $event)}}},'Icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }